module.exports = __webpack_public_path__ + "static/media/pure-natural.df29258e.svg";